export interface IContactChannels {
  type: enContactType;
  name?: string;
  data: string;
}

export enum enContactType {
  WHATSAPP_PHONE = 0,
  TELEGRAM_PHONE = 1,
  EMAIL = 2,
  GENERIC_LINK_STUDY = 3,
  GENERIC_LINK_WARNING = 4,
  GENERIC_LINK_CONTENT = 5
}
